const PequenosNegocios = () => {
  return (
    <div>
      <h1>Apoyo a Pequeños Negocios</h1>
      <p>Recursos y consejos para hacer crecer tu negocio.</p>
    </div>
  );
};

export default PequenosNegocios;
